import { Collapse } from 'antd'
import React from 'react'
const { Panel } = Collapse

import { CollapseContainer } from './styles'

type expandableCardProps = {
  activeKey: string
  headerContent: React.ReactNode
  bodyContent: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}
const ExpandableCard = ({ activeKey, headerContent, bodyContent, onClick }: expandableCardProps) => {
  return (
    <CollapseContainer id="nova-shared-Expandable-Card-root" onClick={onClick}>
      <Collapse activeKey={activeKey} className="collapsable-card" expandIcon={() => <></>}>
        <Panel header={headerContent} key="true">
          {bodyContent}
        </Panel>
      </Collapse>
    </CollapseContainer>
  )
}

export default ExpandableCard
